/* =====================================================================
 * remarkGuideBreaks — 문단 안의 줄바꿈을 화면에서도 줄바꿈으로 보여준다.
 *
 * 표준 markdown 은 한 문단 안의 줄바꿈을 공백으로 합친다. 가이드는 "한 줄에
 * 한 가지 정보" 로 끊어 써야 읽기 편해서, 문서에 적은 줄바꿈을 그대로 살린다.
 * 문단을 나누고 싶으면 빈 줄을 두면 된다(기존 markdown 과 같음).
 *
 * `remark-breaks` 와 같은 동작이지만 의존성을 늘리지 않으려고 여기서 구현한다.
 * ===================================================================== */

interface MdNode {
  type: string;
  value?: string;
  children?: MdNode[];
}

function splitBreaks(node: MdNode): void {
  if (!node.children) return;
  const next: MdNode[] = [];
  for (const child of node.children) {
    if (child.type === 'text' && child.value?.includes('\n')) {
      child.value.split('\n').forEach((part, index) => {
        if (index > 0) next.push({ type: 'break' });
        if (part) next.push({ type: 'text', value: part });
      });
      continue;
    }
    splitBreaks(child);
    next.push(child);
  }
  node.children = next;
}

export function remarkGuideBreaks() {
  return (tree: MdNode) => {
    splitBreaks(tree);
  };
}
